import { styled } from 'styled-components';
import { renderFullPath } from '~/utils/common/utils';
import { classic } from '~/themes';

type IProps = {
  name?: string;
  avatarSrc?: string;
  alt?: string;
};

type TProps = IProps;

export function BattleUserItem({ avatarSrc, name, alt }: TProps) {
  return (
    <Container>
      {avatarSrc && (
        <SDivAvatar>
          <SImg src={renderFullPath(avatarSrc)} alt={alt} />
        </SDivAvatar>
      )}

      <SAvatarSpan>{name}</SAvatarSpan>
    </Container>
  );
}

const SAvatarSpan = styled.div`
  font-family: 'Riffic Free', sans-serif;
  color: ${classic.token?.colorWhite};
  background-color: transparent;
  font-weight: bold;
  font-size: 1.4rem;
  margin-top: 10px;

  @media screen and (max-width: 450px) {
    font-size: 1.2rem;
    margin-top: 5px;
  }
  @media screen and (max-height: 800px) {
    font-size: 1.2rem;
    margin-top: 5px;
  }
`;

const Container = styled.div`
  align-items: center;
  display: flex;
  background-position: center;
  background-size: 100% 100%;
  justify-content: center;
  flex-direction: column;
  min-height: 75px;
  user-select: none;
  width: 100%;
`;

const SDivAvatar = styled.div`
  border-radius: 50%;

  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    #fff;
  height: 200px;
  width: 200px;
  margin-top: 20px;
  position: relative;
  border: 3px solid #fff;

  @media screen and (max-width: 450px) {
    height: 100px;
    width: 100px;
  }
  @media screen and (max-height: 800px) {
    height: 100px;
    width: 100px;
  }
`;

const SImg = styled.img`
  position: absolute;
  object-fit: contain;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;
// classic.token?.colorPrimary
/*
@media screen and (max-width: 300px) {
    @media screen and (max-width: 450px) {
    padding: calc(0.5rem + 6px) 5px 10px 5px;
  }
  @media screen and (max-height: 800px) {
    padding: calc(0.7rem + 10px) 24px;
  }
  }
*/
